import React, { useState, useEffect } from 'react';
import './AboutVenueDetails.css';
import './ReviewSectionDetailPage.css';

import axios from 'axios';
import ClubReviewModal from './ClubReviewModal';
import ReactStars from 'react-stars';
import { API_BASE_URL } from '../../utils';
import ReviewIMG from '../../Assets/review-img.svg';

import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';


export default function ReviewSectionDetailPage({ data }) {
    const url = `${API_BASE_URL}/master/assets/uploads/`;
    const navigate = useNavigate();
    const location = useLocation();

    const isReviewPage = location.pathname.endsWith("/review");


    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ msg: '', headline: '', image: null });

    const [ambienceRating, setAmbienceRating] = useState(0);
    const [foodRating, setFoodRating] = useState(0);
    const [hygieneRating, setHygieneRating] = useState(0);
    const [musicRating, setMusicRating] = useState(0);
    const [pricingRating, setPricingRating] = useState(0);
    const [serviceRating, setServiceRating] = useState(0);

    const [ratingData, setRatingData] = useState({});
    const [reviews, setReviews] = useState([]);
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setFormData((prev) => ({ ...prev, image: file }));
    };

    const fetchReviewData = () => {
        const clubid = new FormData();
        clubid.append('club_id', data.id);

        axios
            .post(`${API_BASE_URL}/master/Api/getDataPost/clubRatings`, clubid)
            .then((response) => {
                if (response.data.msg === true) {
                    setReviews([]);
                    setRatingData({});
                } else {
                    setReviews(response.data.data);
                    setRatingData(response.data.ratingsDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching club ratings:', error);
            });
    };

    useEffect(() => {
        fetchReviewData();
    }, [data.id]);



    return (
        <>
            <div className='ReviewSectionDetailPage'>
                <div className='highlight-section highlight-review-section'>
                    <div className='highlight-review-section-box'>
                        <div className='d-flex-r'>
                            <h6 className='px22'>Share Your Review, Earn Carrots!”</h6>
                            <p className='para16'>Tell us about your experience and help others make better choices. As a thank you, we’ll reward you with carrots for every review you share! cdfgf</p>
                            <div>
                                <button
                                    className="highlight-review-section-button"
                                    onClick={() => {
                                        if (isReviewPage) {
                                            navigate(location.pathname.endsWith(`/${data.id}`)
                                                ? location.pathname
                                                : `${location.pathname}/${data.id}`
                                            );
                                        } else {
                                            navigate(`${location.pathname}/review/${data.id}`);
                                        }
                                    }}
                                >
                                    <i className="fi fi-rr-pencil"></i> Write a review
                                </button>

                            </div>
                        </div>
                        <img className='write-review-img img-responsive' src={ReviewIMG}></img>
                    </div>


                    <div className='review-highlight-section'>
                        {reviews?.length > 0 ? (
                            <>
                                <div className='review-highlight-section-content-wrapper'>
                                    <div className='review-highlight-section-content'>
                                        <div className='review-highlight-section-content-average'>
                                            <h1>{ratingData?.averageTotal?.toFixed(2)}</h1>
                                            <p>of {ratingData?.totalRating} reviews</p>
                                            <span>
                                                <ReactStars
                                                    count={5}
                                                    size={30}
                                                    activeColor="#ffd700"
                                                    borderRadius="20px"
                                                    value={ratingData?.averageTotal?.toFixed(2)}
                                                    isHalf={true}
                                                    edit={false}
                                                />
                                            </span>

                                        </div>

                                    </div>
                                </div>

                                <div className='user-review-list-section'>

                                    {reviews?.map((item, index) => (
                                        <div className='user-review-list-section-content' key={index}>
                                            <div className='user-review-list-section-content-user'>
                                                <div className='user-review-list-section-content-user-img'>
                                                    <img src={url + item?.userDetails?.img} alt="" />
                                                </div>
                                                <div className='user-review-list-section-content-user-name'>
                                                    <h3>{item?.userDetails?.name}</h3>
                                                    <p>{item?.userDetails?.date}</p>
                                                    <p>
                                                        {/* {item?.rating} */}
                                                        <ReactStars
                                                            count={5}
                                                            size={24}
                                                            activeColor="#ffd700"
                                                            value={Number(Math.max(...item?.stars.split(',').map(Number)))}
                                                            isHalf={true}
                                                            edit={false}
                                                        /></p>
                                                    <div className='user-review-list-section-content-review'>
                                                        <p>{item?.msg}</p>
                                                    </div>
                                                    <div className='user-review-list-section-content-review-imgs'>
                                                        {item.images?.map((image, index) => (
                                                            <div className="review-img" key={image.id || index}>
                                                                <img src={url + image.img} alt={`review-${index}`} />
                                                            </div>
                                                        ))}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}


                                </div>
                            </>
                        ) : (
                            <>Be the first to write a review</>
                        )}
                    </div>
                </div>

                {/* <Rating /> */}

                {/* <ClubReviewModal
                    show={showModal}
                    handleClose={() => setShowModal(false)}
                    handleSubmit={handleSubmit}
                    formData={formData}
                    handleInputChange={handleInputChange}
                    handleImageChange={handleImageChange}
                    ambienceRating={ambienceRating}
                    foodRating={foodRating}
                    hygieneRating={hygieneRating}
                    musicRating={musicRating}
                    pricingRating={pricingRating}
                    serviceRating={serviceRating}
                    handleAmbienceRatingChange={setAmbienceRating}
                    handleFoodRatingChange={setFoodRating}
                    handleHygieneRatingChange={setHygieneRating}
                    handleMusicRatingChange={setMusicRating}
                    handlePriceRatingChange={setPricingRating}
                    handleServiceRatingChange={setServiceRating}
                /> */}
            </div>
        </>
    )
}
